// eslint-disable-next-line no-unused-vars
const notifierStyle = (theme) => ({
	whiteBGColor: {
		color: '#000000',
		backgroundColor: '#ffffff',
	},
});

export default notifierStyle;
